import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { Store } from '@ngrx/store';
import { selectIsMagicLink } from 'src/app/auth/ngrx/auth.selectors';
import { State } from 'src/app/reducers';
import { FooterComponent } from 'src/app/layout/components/footer/footer.component';
import { SimpleHeaderComponent } from 'src/app/layout/components/simple-header/simple-header.component';
import { SpinnerComponent } from 'src/app/shared/Components/spinner/spinner.component';
import { InterfaceLanguage } from 'src/app/shared/constants/languages';
import { Language } from 'src/app/shared/Models/models';
import { setInterfaceLang } from 'src/app/shared/ngrx/shared.actions';

@Component({
  selector: 'app-auth-layout',
  imports: [
    FooterComponent,
    RouterOutlet,
    SimpleHeaderComponent,
    SpinnerComponent,
  ],
  templateUrl: './auth-layout.component.html',
  styleUrl: './auth-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthLayoutComponent {
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly translate = inject(TranslocoService);
  private readonly store = inject<Store<State>>(Store);

  readonly lang = computed(
    () => this.translate.activeLang() as InterfaceLanguage,
  );
  readonly magicLink = toSignal(this.store.select(selectIsMagicLink));

  constructor() {
    this.activatedRoute.queryParams.subscribe(this.handleLang);
  }

  handleLang = ({ lang }: { lang: string }) => {
    if (lang) {
      const l = Language(lang);
      this.translate.setActiveLang(l);
      this.store.dispatch(setInterfaceLang({ lang: l }));
    }
  };
}
